import '@/assets/js/bytetrade';
import { getPrivateKey } from '@/service';
import axios from 'axios';
import settings from './settings';
import Config from '@/utils/Config';
import Utils from '@/utils/Utils';
import * as types from '@/store/mutation-types';

require('./gt');

let u;
let p;

function vaildCheck() {
    const pm = new Promise((resolve, reject) => {
        axios
            .get(`${settings.HOST}/bittrade/gt/register1?t=${new Date().getTime()}`, {
                xDomain: true,
            })
            .then((d) => {
                // 调用 initGeetest 进行初始化
                // 参数1：配置参数
                // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
                const data = d.data;
                window.initGeetest(
                    {
                        // 以下 4 个配置参数为必须，不能缺少
                        gt: data.gt,
                        challenge: data.challenge,
                        offline: !data.success, // 表示用户后台检测极验服务器是否宕机
                        new_captcha: data.new_captcha, // 用于宕机时表示是新验证码的宕机
                        product: 'bind', // 产品形式，包括：float，popup
                        width: '300px',
                        // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
                    },
                    (captchaObj) => {
                        captchaObj.onClose(() => {
                            self.loading.close();
                            // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
                        });
                        captchaObj
                            .onReady(() => { })
                            .onSuccess(() => {
                                const result = captchaObj.getValidate();
                                if (!result) {
                                    // TODO
                                }
                                const userName = u;
                                const password = p;
                                const mnemonic = window.bytetrade_js.key.generateMnemonic();
                                const mnemonicSeed = window.bytetrade_js.key.mnemonicToSeedHex(
                                    mnemonic,
                                );
                                // console.log(mnemonic)
                                // self.mnemonic = mnemonic;
                                const privatekey = window.bytetrade_js.PrivateKey.fromSeed(
                                    mnemonicSeed,
                                );
                                const publickey = privatekey.toPublicKey();
                                const address = publickey.toAddressString();
                                const mnemonicCliper = window.bytetrade_js.key.encrypt_mnemonic(
                                    mnemonic,
                                    userName,
                                    password,
                                );
                                const account = {
                                    address,
                                    mnemonic,
                                    mnemoniccliper: mnemonicCliper,
                                    userid: userName,
                                    publickey: publickey.toString(),
                                };
                                const baseAccount = {
                                    address,
                                    mnemoniccliper: mnemonicCliper,
                                    userid: userName,
                                    publickey: publickey.toString(),
                                };
                                const auth = {};
                                auth[address] = 100;
                                const postData = {
                                    geetest_challenge: result.geetest_challenge,
                                    geetest_validate: result.geetest_validate,
                                    geetest_seccode: result.geetest_seccode,
                                    cmd: 'registerAccount',
                                    fee: 3000000,
                                    account: JSON.stringify({
                                        id: userName,
                                        owner: {
                                            weight_threshold: 100,
                                            account_auths: {},
                                            key_auths: {},
                                            address_auths: auth,
                                        },
                                        active: {
                                            weight_threshold: 100,
                                            account_auths: {},
                                            key_auths: {},
                                            address_auths: auth,
                                        },
                                    }),
                                };
                                axios
                                    .post(settings.SERVER_PREFIX, postData)
                                    .then((dd) => {
                                        const status = parseInt(dd.data.code, 10);
                                        if (status === 0) {
                                            const accountPrivatekey = getPrivateKey(
                                                baseAccount,
                                                password,
                                            );
                                            const back = {
                                                accountPrivatekey,
                                                data,
                                                baseAccount,
                                                account,
                                            };
                                            resolve(back);
                                        }
                                    })
                                    .catch((e) => {
                                        reject(e);
                                    });
                            });
                        window.captchaObj = captchaObj;
                    },
                );
            })
            .catch(() => {
                reject({
                    msg: 'Error',
                });
            });
    });
    return pm;
}

function isalnum(char) {
    return (
        (char >= 'A' && char <= 'Z') ||
        (char >= 'a' && char <= 'z') ||
        (char >= '0' && char <= '9')
    );
}

// eslint-disable-next-line camelcase
function is_valid_id(id) {
    if (id.length < 3) {
        return false;
    }
    // 字符串不能小于3个,不能大于32个 不能以BTT任意大小写开头  不能连续含有一个 . _ @  字符串
    if (id.length > 32) {
        return false;
    }

    if (
        (id[0] === 'B' || id[0] === 'b') &&
        (id[1] === 'T' || id[1] === 't') &&
        (id[2] === 'T' || id[2] === 't')
    ) {
        return false;
    }

    let isPrefix = false;
    let bool = true;
    const splitUsername = Array.from(id);
    const userLen = splitUsername.length;
    for (let i = 0; i < userLen; i += 1) {
        const c = splitUsername[i];
        if (isalnum(c) === false) {
            if (c === '.' || c === '_' || c === '@') {
                if (isPrefix) {
                    bool = false;
                    break;
                }
            } else {
                isPrefix = false;
            }
        }
    }
    return bool;
}

function createAccount(username, password, repassword, checkInviter) {
    const pm = new Promise((resolve, reject) => {
        u = username;
        p = password;
        const rep = repassword;
        // 判断两次输入密码是否一致
        if (!u || !password) {
            // reject('pass word unsame');
        }
        if (p === rep) {
            // reject('password unsame');
        }
        if (!is_valid_id(u)) {
            // reject('pass word unsame');
        }
        if (password.length < 6) {
            // reject('password too short');
        }
        const verifyData = {
            cmd: settings.cmd.register,
            userid: u,
        };
        axios({
            method: 'post',
            url: `${settings.SERVER_PREFIX}/me`,
            data: verifyData,
        }).then((res) => {
            if (res.data.code === 0) {
                const userName = u;
                const mnemonic = window.bytetrade_js.key.generateMnemonic();
                const mnemonicSeed = window.bytetrade_js.key.mnemonicToSeedHex(
                    mnemonic,
                );
                // console.log(mnemonic)
                // self.mnemonic = mnemonic;
                const privatekey = window.bytetrade_js.PrivateKey.fromSeed(
                    mnemonicSeed,
                );
                const publickey = privatekey.toPublicKey();
                const address = publickey.toAddressString();
                const mnemonicCliper = window.bytetrade_js.key.encrypt_mnemonic(
                    mnemonic,
                    userName,
                    password,
                );
                const account = {
                    address,
                    mnemonic,
                    mnemoniccliper: mnemonicCliper,
                    userid: userName,
                    publickey: publickey.toString(),
                };
                const baseAccount = {
                    address,
                    mnemoniccliper: mnemonicCliper,
                    userid: userName,
                    publickey: publickey.toString(),
                };
                const auth = {};
                auth[address] = 100;
                const postData = {
                    cmd: 'registerAccountNew',
                    fee: 3000000,
                    account: JSON.stringify({
                        id: userName,
                        owner: {
                            weight_threshold: 100,
                            account_auths: {},
                            key_auths: {},
                            address_auths: auth,
                        },
                        active: {
                            weight_threshold: 100,
                            account_auths: {},
                            key_auths: {},
                            address_auths: auth,
                        },
                    }),
                };
                const inviter = Utils.getQueryObject().inviter;
                if (inviter && inviter != '' && checkInviter) {
                    postData.inviter = inviter;
                }
                axios
                    .post(settings.SERVER_PREFIX_V2, postData)
                    .then((dd) => {
                        const status = parseInt(dd.data.code, 10);
                        if (status === 0) {
                            const accountPrivatekey = getPrivateKey(baseAccount, password);
                            const data = {
                                code: 0,
                            };
                            if (dd.data.inviter && dd.data.inviter != '') {
                                baseAccount.inviter = dd.data.inviter;
                            } else if (settings.dapp && settings.dapp != '') {
                                baseAccount.inviter = settings.dapp;
                            } else {
                                baseAccount.inviter = 'Sagittarius';
                            }
                            const back = {
                                accountPrivatekey,
                                data,
                                baseAccount,
                                account,
                            };
                            resolve(back);
                        } else {
                            reject(dd.data);
                        }
                    })
                    .catch((e) => {
                        reject(e);
                    });
                // if (window.captchaObj) {
                //     window.captchaObj.verify();
                //     resolve({
                //         code: 0,
                //         errmsg: 'success',
                //     });
                // } else {
                //     const capCatch = setInterval(() => {
                //         if (window.captchaObj !== 'undefined') {
                //             window.captchaObj.verify();
                //             clearInterval(capCatch);
                //         }
                //     }, 1000);
                // }
            } else {
                reject({
                    code: 403,
                    errmsg: 'account_username_already_exist',
                });
            }
        });
    });
    return pm;
}

function ImportAccount(m, pwd, type = 'account_type_mnemonics') {
    // eslint-disable-next-line no-unused-vars
    const pm = new Promise((resolve, reject) => {
        // eslint-disable-next-line no-console
        let accountInfo = {};
        let mnemonic = m.trim();
        const password = pwd;
        const mnemonics = mnemonic.split(' ');
        mnemonic = mnemonics.slice(0, mnemonics.length - 1).join(' ');
        let bttAddress = null;
        const userName = mnemonics[mnemonics.length - 1];
        if (type === 'account_type_mnemonics') {
            if (mnemonics.length < 5) {
                reject({ code: 403, errmsg: 'account_mnemonics_length_error' });
            }
            const mnemonicSeed = window.bytetrade_js.key.mnemonicToSeedHex(mnemonic);
            const privatekey = window.bytetrade_js.PrivateKey.fromSeed(mnemonicSeed);
            const publickey = privatekey.toPublicKey();
            bttAddress = publickey.toAddressString();
            const mnemonicCliper = window.bytetrade_js.key.encrypt_mnemonic(
                mnemonic,
                userName,
                password,
            );
            accountInfo = {
                address: bttAddress,
                backup: true,
                mnemoniccliper: mnemonicCliper,
                userid: userName,
                publickey: publickey.toString(),
            };
        } else {
            const privatekey = window.bytetrade_js.PrivateKey.fromHex(mnemonic);
            const publickey = privatekey.toPublicKey();
            bttAddress = publickey.toAddressString();
            const mnemonicCliper = window.bytetrade_js.key.encrypt_mnemonic(
                mnemonic,
                userName,
                password,
            );
            accountInfo = {
                address: bttAddress,
                backup: true,
                mnemoniccliper: mnemonicCliper,
                privatekey: true,
                userid: userName,
                publickey: publickey.toString(),
            };
        }

        axios
            .get(
                `${settings.HOST}/bittrade/v1/me`,
                {
                    params: {
                        cmd: 'getUserInviter',
                        userid: userName,
                    },
                },
            )
            .then((response) => {
                const inviter = response.data.inviter;
                axios
                    .get(`${settings.HOST}/bittrade/BlockServlet`, {
                        params: {
                            cmd: settings.cmd.users,
                            userid: userName,
                        },
                    })
                    .then((res) => {
                        if (
                            res.data.res.length > 0 &&
                            res.data.res[0].address === bttAddress
                        ) {
                            if (inviter && inviter != '') {
                                accountInfo.inviter = inviter;
                            } else if (settings.dapp != '') {
                                accountInfo.inviter = settings.dapp;
                            } else {
                                accountInfo.inviter = 'Sagittarius';
                            }

                            const userInfo = {
                                data: res.data.res,
                                account: accountInfo,
                            };
                            resolve(userInfo);
                        } else {
                            reject({ code: 403, errmsg: 'account_username_invaild' });
                        }
                    });
            });
    });
    return pm;
}

function checkUserNameStatus(username) {
    const pm = new Promise((resolve) => {
        const data = {
            cmd: settings.cmd.register,
            userid: username,
        };
        axios.post(`${settings.SERVER_PREFIX}/me`, data).then((res) => {
            if (res.data.code === 0) {
                resolve(res.data);
            } else {
                resolve(res.data);
            }
        });
    });
    return pm;
}

function checkInviter(userid, self) {
    /* 20200116: use dappId as inviter, so skip this fucntion */
    // const accountList = self.$store.state.accountList;
    // const users = accountList.filter(item => item.userid == userid);
    // const user = users[0];
    // if (user.inviter == undefined) {
    //     axios.get(
    //         `${settings.HOST}/bittrade/v1/me`,
    //         {
    //             params: {
    //                 cmd: 'getUserInviter',
    //                 userid,
    //             },
    //         },
    //     ).then((response) => {
    //         const inviter = response.data.inviter;
    //         user.inviter = inviter;
    //         self.$store.commit(types.EDIT_ACCOUNT, user);
    //     });
    // }
}

function getMnemonic(account, password, remember) {
    const pm = new Promise((resolve, reject) => {
        const mnemonicRecover = window.bytetrade_js.key.decrypt_mnemonic(
            account.mnemoniccliper,
            account.userid,
            password,
        );
        if (
            (mnemonicRecover === '' && !mnemonicRecover.indexOf(' ') >= 0) ||
            Array.from(mnemonicRecover).filter(item => item >= 'A' && item <= 'Z')
                .length > 0
        ) {
            reject({ code: 403, errmsg: 'account_password_wrong' });
        }
        if (remember) {
            if (window.password) {
                window.password[account.userid] = password;
            } else {
                window.password = {};
                window.password[account.userid] = password;
            }
        }
        const privateKey = getPrivateKey(account, password).toHex();
        const mnemonic = mnemonicRecover;
        resolve({ code: 0, mnemonic, privateKey });
    });
    return pm;
}

function getDepositAddress(userId) {
    const pm = new Promise((resolve) => {
        axios
            .get(`${settings.pixiu}`, {
                params: {
                    needAssetJSON: 1,
                    cmd: settings.cmd.depositAddress,
                    userid: userId,
                },
            })
            .then((res) => {
                if (res.data.code === 2 || res.data.code === 0) {
                    const rlt = {
                        code: 0,
                        data: res.data,
                    };
                    resolve(rlt);
                } else {
                    const rlt = {
                        code: -1,
                        data: {},
                        errmsg: 'Error',
                    };
                    resolve(rlt);
                }
            });
    });
    return pm;
}

export default {
    vaildCheck,
    createAccount,
    ImportAccount,
    getMnemonic,
    getDepositAddress,
    checkUserNameStatus,
    checkInviter,
};



// WEBPACK FOOTER //
// ./src/utils/Ruc.js